import { API_APP_USER_PORTAL_ROUTE, API_LOGIN_CONFIGURATION_ROUTE, API_MENU_REPORT_ROUTE } from 'config/api-consts';
import {
  APP_USER_ROUTE,
  LOGIN_CONFIGURATION_ROUTE,
  MENU_REPORT_ROUTE,
  ORGANIZATION_ROUTE,
  POSITION_ROUTE,
  PROFILE_ROUTE,
  ROLE_ROUTE,
  USER_NOTIFICATION_ROUTE,
  LICENSE_INFORMATION_ROUTE,
} from 'config/route-consts';
import { translate } from 'core/helpers/internationalization';
import { RouteConfig } from 'react-router-config';
import { API_ORGANIZATION_ROUTE, API_POSITION_ROUTE, API_ROLE_ROUTE, API_SITE_ROUTE } from './api-consts';
import { SITE_ROUTE } from './route-consts';




export const menu: RouteConfig[] = [
  {
    name: translate('menu.appUsers'),
    path: APP_USER_ROUTE,
    validPath: `/${`${API_APP_USER_PORTAL_ROUTE}`}/list`,
    key: APP_USER_ROUTE,
    icon: 'tio-user_add',
  },

  {
    name: translate('menu.roles'),
    path: ROLE_ROUTE,
    validPath: `/${`${API_ROLE_ROUTE}`}/list`,
    key: ROLE_ROUTE,
    icon: 'tio-group_senior',
  },
  {
    name: translate('menu.site'),
    path: SITE_ROUTE,
    validPath: `/${`${API_SITE_ROUTE}`}/list`,
    key: SITE_ROUTE,
    icon: 'tio-group_senior',
  },
  {
    name: translate('menu.organization'),
    path: ORGANIZATION_ROUTE,
    validPath: `/${`${API_ORGANIZATION_ROUTE}`}/list`,
    key: ORGANIZATION_ROUTE,
    icon: 'tio-category_outlined',
  },
  {
    name: translate('menu.position'),
    path: POSITION_ROUTE,
    validPath: `/${`${API_POSITION_ROUTE}`}/list`,
    key: POSITION_ROUTE,
    icon: 'tio-files_labeled_outlined',
  },
  // {
  //   notTitle: false,
  //   name: translate('menu.administrativeUnits'),
  //   path: OFFICIAL_ROOT_ROUTE,
  //   key: OFFICIAL_ROOT_ROUTE,
  //   icon: 'tio-earth_west',
  //   children: [
  //     {
  //       name: translate('menu.provinces'),
  //       path: PROVINCE_ROUTE,
  //       key: PROVINCE_ROUTE,
  //       icon: 'tio-route',
  //     },
  //     {
  //       name: translate('menu.districts'),
  //       path: DISTRICT_ROUTE,
  //       key: DISTRICT_ROUTE,
  //       icon: 'tio-route',
  //     },
  //     {
  //       name: translate('menu.wards'),
  //       path: WARD_ROUTE,
  //       key: WARD_ROUTE,
  //       icon: 'tio-route',
  //     },
  //   ],
  // },

  {
    name: translate('menu.loginConfiguration'),
    path: LOGIN_CONFIGURATION_ROUTE,
    validPath: `/${`${API_LOGIN_CONFIGURATION_ROUTE}`}/list`,
    key: LOGIN_CONFIGURATION_ROUTE,
    icon: 'tio-group_senior',
  },

  {
    name: translate('menu.menuReport'),
    path: MENU_REPORT_ROUTE,
    validPath: `/${`${API_MENU_REPORT_ROUTE}`}/list`,
    key: MENU_REPORT_ROUTE,
    icon: 'tio-file_text_outlined',
  },

  {
    name: translate('menu.linsenceInformations'),
    path: LICENSE_INFORMATION_ROUTE,
    validPath: `/${`${API_MENU_REPORT_ROUTE}`}/list`,
    key: LICENSE_INFORMATION_ROUTE,
    icon: 'tio-notifications_on_outlined',
  },

];

export const menuProfile: RouteConfig[] = [
  {
    name: translate('menu.userAccount'),
    path: PROFILE_ROUTE,
    key: 'official-user-account',
    icon: 'tio-account_circle',
  },
  {
    name: translate('menu.userNotifications'),
    path: USER_NOTIFICATION_ROUTE,
    key: 'official-user-notification',
    icon: 'tio-notifications_on_outlined',
  },


];

// function checkVisible(
//   ...urls: string[]
// ): (object: Record<string, number>) => boolean {
//   return (object: Record<string, number>) => {
//     let display = false;
//     if (urls.length > 0) {
//       urls.forEach(item => {
//         if (object.hasOwnProperty(item)) display = true;
//       });
//     }
//     return display;
//   };
// } // check whether title is visible or not
